import { useApi } from './useApi';
import { url } from '../../utils/confserveur';
export const useEval = (evalID, refreshData) => {
  const urlfetch = evalID ? `${url}evaluations/${evalID}` : url+'evaluations/';
 
  return useApi(urlfetch, [], refreshData,null);
};